import api from './api';
import { fetchAndSave } from '../utils/downloadResponse';
import { BulkMarksOutcome } from '../types/examination';

/** Which marks sheet: an exam of a class, for one section or the whole class. */
export interface BulkMarksScope {
  sessionId: string;
  classId: string;
  sectionInstanceId?: string | null;
  examId: string;
}

/**
 * Marks by spreadsheet. The template lists the exam's students with their
 * current marks filled in; uploading it back records only what changed,
 * under the same rules as Enter Marks.
 */
export const bulkResultService = {
  downloadTemplate: ({ sessionId, classId, sectionInstanceId, examId }: BulkMarksScope) =>
    fetchAndSave(
      () => api.get(`/examination/sessions/${sessionId}/classes/${classId}/result-template`, { params: { examId, sectionInstanceId: sectionInstanceId || undefined }, responseType: 'blob' }),
      'marks.csv',
    ),

  upload: async (file: File, scope: BulkMarksScope): Promise<BulkMarksOutcome> => {
    const form = new FormData();
    form.append('csv', file);
    form.append('sessionId', scope.sessionId);
    form.append('classId', scope.classId);
    form.append('examId', scope.examId);
    if (scope.sectionInstanceId) form.append('sectionInstanceId', scope.sectionInstanceId);
    const response = await api.post('/examination/bulk-results', form, { headers: { 'Content-Type': 'multipart/form-data' } });
    return response.data.data;
  },
};
